export default __webpack_public_path__ + "static/media/Tom Kuhn.2521fb44.png";